import { submitUserCustomSettings, updateUserCustomSettings } from "api";
import Cookies from "js-cookie";
import React, { useReducer, useEffect, useLayoutEffect } from "react";
import { useIntl } from "react-intl";
import JoyRide, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import tourInitialState from "../tourInitialState";
import tourReducer from "../tourReducer";
import TourTooltip from "../TourTooltip";
import getListViewTourSteps from "./listViewTourSteps";

function ListViewTour() {
  const intl = useIntl();
  const TOUR_STEPS = getListViewTourSteps(intl);

  const [tourState, dispatch] = useReducer(tourReducer, tourInitialState);

  // Starts tour if runDashboardTour is true
  useLayoutEffect(() => {
    const customSettings = JSON.parse(localStorage.getItem("customSettings") || null);
    const prevState = customSettings && customSettings.tourState;
    if ((prevState && prevState.runListViewTour === false) || Cookies.get("cargobase_logged_in_as_token")) {
      dispatch({ type: "STOP" });
      return;
    }
    dispatch({ type: "START" });
  }, []);

  // Updates tourState in localStorage and API when tour is stopped
  useEffect(() => {
    if (Cookies.get("is_guest") === "true") return;
    const customSettings = JSON.parse(localStorage.getItem("customSettings")) || {};
    if (!tourState.run && !Cookies.get("cargobase_logged_in_as_token")) {
      // update custom settings via API
      const func = customSettings ? updateUserCustomSettings : submitUserCustomSettings;
      func({ tourState: { ...customSettings.tourState, runListViewTour: tourState.run } }).then((res) =>
        localStorage.setItem("customSettings", JSON.stringify(res.data)),
      );
    }
  }, [tourState]);

  const handleJoyrideCallback = (data) => {
    const { action, index, type, status } = data;
    if (action === ACTIONS.CLOSE || (status === STATUS.SKIPPED && tourState.run) || status === STATUS.FINISHED) {
      dispatch({ type: "STOP" });
    } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      dispatch({
        type: "NEXT_OR_PREV",
        payload: { stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
      });
    }
  };

  return <JoyRide {...tourState} callback={handleJoyrideCallback} steps={TOUR_STEPS} tooltipComponent={TourTooltip} />;
}

export default ListViewTour;
